import * as log from 'loglevel';

const logger = log;
export { logger };
